"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var border = function (color) { return "border: 1px solid " + color + ";"; };
exports.default = (function (_a) {
    var checked = _a.checked, hovered = _a.hovered;
    return function (_a) {
        var theme = _a.theme;
        if (hovered) {
            return border(theme.palette.inputRadioBorderHover);
        }
        return border(checked ? theme.palette.inputRadioBgChecked : theme.palette.inputRadioBorder);
    };
});
